import CitiesService from '../services/CitiesService';

class Cities {

  static getInstance() {
    if (!this.myInstance) {
      this.myInstance = new Cities();
    }

    return this.myInstance;
  }

  async fetchCities() {
    this.cities = await CitiesService.fetchCities();

    this.cities = this.cities.sort((a, b) =>
      a.name.toLowerCase() > b.name.toLowerCase() ? 1
        : (a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 0));

    return this.cities;
  }

  async getCities() {
    if (!this.cities) {
      await this.fetchCities();
    }

    return this.cities;
  }

  async getCitiesName(cityIds) {
    if (cityIds[0] === null) {
      return 'Carecity';
    }

    let userCitiesString = '';
    const cities = await this.getCities();

    cityIds.forEach(cityId => {
      const city = cities.find(city => city.cityId === cityId);
      if (city) {
        userCitiesString += city.name + ', ';
      }
    });

    userCitiesString = userCitiesString.slice(0, -2);

    return userCitiesString;
  }
}

export default Cities;
